import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const PasswordStore = {
  state: {
    passwords: [],
    password: {}
  },
  getters,
  mutations,
  actions
}

export default PasswordStore